<template>
  <div class="modifyUserItem"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': MaterialPane_Size.width+'px', 'z-index': boxData.Zindex, }"  @mousedown="stopDocument($event)">
    <div class="dragArea" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': (boxData.moveoks?'move':'move')}">
      <i @click="close()" class="icon-popup-close"></i>
    </div>
    <div class="spriteBoody" @keydown.stop>
      <!---->
      <div class="title" v-if="!loading && false">
        <span>名称</span>
        <el-input
          class="title-text"
          @focus="togglePreventDefault(false)"
          @blur="togglePreventDefault(true);changeText('title')"
          placeholder="请输入名称"
          v-model="scenesMsg.title"
          :maxlength="scenesMsg.titleLength"
          resize="none">
        </el-input>
      </div>
      <div class="label" v-if="!loading && false">
        <span>标签</span>
        <div class="labelBox" v-on:keyup.enter="addLabel($event)" >
          <div v-for="(item, index) in scenesMsg.labelArray" :key="index" >
            {{item.name}}
            <span class="el-icon-close" @click="delLabel(index)"></span>
          </div>
          <el-input
            class="label-text"
            @focus="togglePreventDefault(false)"
            @blur="togglePreventDefault(true);changeText('label')"
            placeholder="请输入标签"
            v-model="scenesMsg.label"
            :maxlength="20"
            resize="none">
          </el-input>
        </div>
      </div>
      <!---->
      <div class="title" v-if="!loading && boxName == 'scene'">

        请确认是否取消收藏当前场景页？

      </div>
      <div class="title" v-if="!loading && boxName !== 'scene'">

        请确认是否删除您所选择的素材？

      </div>
      <div v-loading="loading"
        v-if="loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        element-loading-text="加载中..."
        element-loading-spinner="el-laihua-loading"
        style="width: 100%;height: 60px;"
      ></div>

      <div v-if="!loading" class="cancel">
        <el-button v-if="boxName == 'scene'" size="medium" type="primary" @click="close()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;仍然收藏&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        <el-button v-if="boxName != 'scene'" size="medium" type="primary" @click="close()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        <el-button v-if="boxName != 'scene'" size="medium" type="danger" @click="cancelScenes()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;删除&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
        <el-button v-if="boxName == 'scene'" size="medium" type="primary" @click="cancelScenes()">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;取消收藏&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
      </div>

    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import popupSecond from '../../mixins/popupSecond'

export default {
  mixins: [popupSecond],
  data() {
    return {
      boxDataName : 'modifyUserItem', // 弹窗名称
      scenesMsg   : {
        title  : '',
        titleLength : 8,
        label  : '',
        labelArray : [],  // 标签数组
      },
      loading     : false,
      boxName     : '',
      typeName    : '',
      oldItemMsg  : null, // 旧的数据
    };
  },
  watch : {
    'boxDatas.secondData' : function(val, oldval){ // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.secondData, this.boxDataName);
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
        this.boxData.Zindex   = (this.dataMsg.length + 1 )*5;
        this.boxData.data     = this.dataMsg[this.boxDataName].data;
        this.boxData.fix.x    = this.dataMsg[this.boxDataName].posx+2;
        this.boxData.fix.y    = this.dataMsg[this.boxDataName].posy+2;
        this.boxName          = this.dataMsg[this.boxDataName].boxName;
        this.typeName         = this.dataMsg[this.boxDataName].typeName || false;
        this.getUserItemMsg(this.dataMsg[this.boxDataName].boxName);
      }
    },
  },
  props: [],
  computed: {
    ...mapGetters([
      'S_SearchData',
      'MaterialPane_Size'
    ])
  },
  mounted () {
   this.$bus.on('modifyUserItem_vue',(data) => {
      if(this.TOOL && this.boxData.judgeBox && this.boxData.data.id !== data.data.id){ // 打开的操作

        this.boxData.data  = data.data;
        this.boxData.fix.x = data.posx+2;
        this.boxData.fix.y = data.posy+2;
        this.boxName       = data.boxName;
        this.getUserItemMsg(data.boxName);
      }
    });
    this.$bus.on('windowMousedown_vue',(data) => {
      if(this.TOOL && this.boxData.judgeBox && this.boxData.data.id !== data.data.id){ // 打开的操作
        this.close();
      }
    });
  },
  methods: {
    togglePreventDefault(val) {
      // 是否启用快捷键
      this.$store.commit('toggle_isPreventDefault', val);
    },
    changeText(data){	  // 判断标题等
			if(data === 'title'){
				if(!this.scenesMsg.title.length){
					this.scenesMsg.title = '我的素材～';
				}
        if(this.scenesMsg.title.length > this.scenesMsg.titleLength){
					this.scenesMsg.title = this.scenesMsg.title.slice(0, this.scenesMsg.titleLength);
				}
        this.modifyScenes();
			}else if(data === 'label'){
				if(this.scenesMsg.label.length > 5){
					this.scenesMsg.label = this.scenesMsg.label.slice(0, 5);
				}
			}
		},
    addLabel(el){     // 添加标签
      if(this.scenesMsg.label.length > 5){
        this.scenesMsg.label = this.scenesMsg.label.slice(0, 5);
      }
      if(this.scenesMsg.labelArray.length < 5){
        this.scenesMsg.labelArray.push({ name: this.scenesMsg.label });
      }
      el.path[0].blur();
      this.scenesMsg.label = '';
      this.modifyScenes();
    },
    delLabel(data){ // 删除标签
      this.scenesMsg.labelArray.splice(data, 1);
      this.modifyScenes();
    },
    modifyScenes(){ // 修改元素
      let scenesData = {},
          urlData    = this.utlData();;
          scenesData.tags       = JSON.stringify(this.scenesMsg.labelArray);
          scenesData.title      = this.scenesMsg.title

      this.$http.put('/api/user/'+ urlData +'/' + this.boxData.data.id, scenesData)
        .then((resScenes) => {
          switch(this.boxName){ // 元素旧的数据改变判断
            case 'sound':
              if(this.oldItemMsg.title !== this.scenesMsg.title){
                this.$bus.emit('modifyUserItem_del_vue',{type: this.boxName, boxName:this.typeName});
              }
              break;
          }
          this.oldItemMsg.title = this.scenesMsg.title; // 元素旧的数据
        })
        .catch((Serror) => {
          console.log(Serror, '失败')
        })
    },
    getUserItemMsg(id){ // 获取收藏元素具体信息
      let data = {
        id   : this.boxData.data.id
      },
        urlData = this.utlData();
      if (this.boxData.data.musicType === 1) {
        data.musicType = 1;
      }

      if(!urlData)return;

      this.scenesMsg.labelArray = [];
      this.loading = true;
      this.$http.get('/api/user/' + urlData, {
        params: data,
      })
      .then((res) => {
        this.scenesMsg.titleLength = 8;
        let tagId   = [],
            tagText = []
        // console.log(this.dataMsg[this.boxDataName].boxName, this.boxDataName)
        switch(this.dataMsg[this.boxDataName].boxName){ // 不同盒子的数据改变
          case 'pic':
            tagId   = res.data.data.picTag ? res.data.data.picTag.tag.id   : '';
            tagText = res.data.data.picTag ? res.data.data.picTag.tag.name : '';
            this.scenesMsg.title  = res.data.data.title;
            this.oldItemMsg = res.data.data; // 元素旧的数据
            if(res.data.data.picTag){
              let dataId   = tagId ?
                              ( tagId.indexOf(',')   === -1 ? [tagId]   : tagId.split(",") )
                            :
                              [],
                  dataName = tagText ?
                              ( tagText.indexOf(',')   === -1 ? [tagText]   : tagText.split(",") )
                            :
                              [];
              for(let i = 0; i < dataId.length; i++){
                this.scenesMsg.labelArray.push({
                  id   : dataId[i],
                  name : dataName[i]
                });
              }
            }
            break;
          case 'music':
          case 'musicType':
          case 'team':
            this.scenesMsg.titleLength = 50;
            tagId   = res.data.data.musicTag ? res.data.data.musicTag.tag.id   : '';
            tagText = res.data.data.musicTag ? res.data.data.musicTag.tag.name : '';
            this.scenesMsg.title  = res.data.data.title;
            this.oldItemMsg = res.data.data; // 元素旧的数据
            if(res.data.data.musicTag){
              let dataId   = tagId ?
                              ( tagId.indexOf(',')   === -1 ? [tagId]   : tagId.split(",") )
                            :
                              [],
                  dataName = tagText ?
                              ( tagText.indexOf(',')   === -1 ? [tagText]   : tagText.split(",") )
                            :
                              [];
              for(let i = 0; i < dataId.length; i++){
                this.scenesMsg.labelArray.push({
                  id   : dataId[i],
                  name : dataName[i]
                });
              }
            }
            break;
          default:
            this.scenesMsg.title  = res.data.data.title;
            this.oldItemMsg = res.data.data; // 元素旧的数据
            if(res.data.data.sceneTag){
              let dataId   = res.data.data.sceneTag.tag.id.split(","),
                  dataName = res.data.data.sceneTag.tag.name.split(",");
              for(let i = 0; i < dataId.length; i++){
                this.scenesMsg.labelArray.push({
                  id   : dataId[i],
                  name : dataName[i]
                });
              }
            }
        }
        this.loading = false;
      });
    },
    cancelScenes(){     // 取消收藏单个元素
      let data = {
        id   : this.boxData.data.id
      },
      urlData = this.utlData();

      this.$http.delete('/api/user/' + urlData + '/' + this.boxData.data.id, data)  // 收藏scenes
        .then((resScenes) => {
          this.$bus.emit('modifyUserItem_del_vue',{type: this.boxName, boxName: this.typeName});
        })
        .catch((Serror) => {
          console.log(Serror, '失败')
        })
      this.close();
    },
    stopDocument(e){    // 防止事件冒泡
      e.stopPropagation();
    },
    utlData(){ // 不同盒子的数据改变
      let urlData = '';

      switch(this.boxName){
        case 'scene':
          urlData = 'scene';
          break;
        case 'pic':
          urlData = 'pic';
          break;
        case 'music':
        case 'musicType':
        case 'team':
          urlData = 'music';
          break;
      }
      return urlData;
    }
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
  .modifyUserItem{

    .spriteBoody{

      .title{

        .title-text{

          input{
            background: rgb(235,235,246);
            border: none;

          }
        }
      }

      .label{

        .label-text{

          input{
            height: 100%;
            padding: 0 2px;
          }
        }
      }
    }
  }

</style>
<style scoped lang="scss">
  .modifyUserItem{
    position: fixed;
    top: 0;
    left: 0;
    width: 450px;
    height: auto;
    z-index: 35;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    border-radius: 6px 6px 3px 3px;
    border: 1px solid #d8dee9;
    background: #fff;
    overflow: hidden;
    .spriteBoody{
      .label,
      .title,
      .cancel{
        padding: 20px;
        height: 60px;
        position: relative;

        >span{
          position: absolute;
          top: 31px;
          left: 13px;
        }
      }
      .title{

        .title-text{
          width: 380px;
          margin-left: 33px;
        }
      }
      .label{
        height: auto;
        min-height: 40px;

        .labelBox{
          padding-bottom: 5px;
          display: flex;
          flex-wrap: wrap;
          width: 380px;
          margin-left: 33px;
          min-height: 40px;

          >*{
            margin-top: 5px;
            margin-left: 10px;
          }

          >div{
            margin-top: 9px;
            height: 30px;
            line-height: 20px;
            padding: 5px;
            background: rgb(233, 236, 247);
            border-radius: 10px;
            span{
              padding: 1px;
              color: #9c9797;
              font-weight: 900;
              font-size: 16px;
              position: relative;
              top: 2px;
              cursor: pointer;
              &:hover{
                background: #fff;
                border-radius: 100%;
              }
            }
          }

          .label-text{
            width: 88px;
            padding: 0;
            background: none;
          }
        }

      }
      .cancel{
        padding-top: 50px;
        min-height: 120px;
        >span{
          position: relative;
          display: inline-block;
          top: -3px;
          left: 0px;
          width: 112px;
          height: 30px;
          line-height: 30px;
          border-radius: 8px;
          background-color: #d8dee9;
          cursor: pointer;
          span{
            position: relative;
            display: inline-block;
            top: 2px;
            left: -5px;
            width: 15px;
            height: 15px;
            background: url('../../../../static/svg/heart.svg') no-repeat center;
          }

          &:hover{
            background: #b6c3da;
            span{
              background: url('../../../../static/svg/heart-active.svg') no-repeat center;
            }
          }
        }
      }
    }

    .dragArea{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 15px;
      height: 28px;
      position: relative;

      i {
        position: absolute;
        right: 7px;
        top: 7px;
        display: inline-block;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }
  }

  .el-button.el-button--danger.el-button--medium {
    background-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/secondPopups/modifyUserItem.vue